// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__10G5q","row":"Node_row__1cC56","label":"Node_label__3ROdl","footer":"Node_footer__1q8EO"};